import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import { CSSTransition } from 'react-css-transition'
import TransitionStyles from '../../lib/transitionStyles'
import CartStandalonePurchase from '../CartStandalonePurchase'

const CompletedStep = ({ items, skus }) => (
  <div className="mx-auto">
    <CSSTransition {...TransitionStyles} transitionAppear active>
      <h5 className="text-harbor-80 uppercase text-sky tracking-wide-2xl">
        <FormattedMessage id="renewals.category" defaultMessage="Renewals" />
      </h5>
      <h1 className="text-4xl border-b pb-8">
        <FormattedMessage id="renewals.payment.header" />
      </h1>

      <div className="sm:flex mt-6">

        <div className="flex">
          <p className="sm:pr-12">
            <FormattedMessage id="renewals.completed.description" />
          </p>
        </div>

        <div className="flex flex-col mt-6 sm:mt-0">
          <div className="flex justify-end">
            <Link to="/dashboard" className="sm:mr-0 bg-grass whitespace-no-wrap font-bold text-white italic rounded-full uppercase leading-normal tracking-wide focus:outline-none py-2 px-4 sm:py-4 sm:px-8 text-lg">
              <FormattedMessage id="booking.completed.buttons.mybookings" defaultMessage="My bookings" />
            </Link>
          </div>
          <div className="flex justify-end">
            <Link to="/bookings" className="mt-6 bg-sky whitespace-no-wrap font-bold text-white italic rounded-full uppercase leading-normal tracking-wide focus:outline-none py-2 px-4 sm:py-4 sm:px-8 text-lg">
              <FormattedMessage
                id="dashboard.newBooking"
                defaultMessage="New booking"
              />
            </Link>
          </div>
        </div>
      </div>
          
      <div className="mt-8">
        <CartStandalonePurchase
          items={items}
          skus={skus}
        />
      </div>
    </CSSTransition>
  </div>
)

export default CompletedStep